module.exports = __webpack_public_path__ + "static/media/npm.07b3134c.svg";